export default __webpack_public_path__ + "static/media/avatar-1.03e46d2c.jpg";